import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { Typography } from '@mui/material'

import SearchBarComponent from '../../../../../../components/searchBarComponent'

const MembersSearch = ({ getUsers, groupName }) => {
  const { t } = useTranslation()
  const [searchText, setSearchText] = useState('')

  return (
    <div>
      <Typography
        style={{
          fontSize: '1.5rem',
          fontWeight: '700',
          fontFamily: 'Johnson Display',
        }}
      >
        {t('edit-members-modal-title')}
      </Typography>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          gap: '4px',
        }}
      >
        <Typography
          style={{
            fontSize: '1rem',
            fontWeight: '400',
            fontFamily: 'Johnson Text',
          }}
        >
          {t('edit-members-modal-group-name')}
        </Typography>
        <Typography
          style={{
            fontSize: '1rem',
            fontWeight: 'bold',
            fontFamily: 'Johnson Text',
          }}
        >
          {groupName}
        </Typography>
      </div>
      <SearchBarComponent
        searchText={searchText}
        setSearchText={setSearchText}
        getUsers={getUsers}
        isModal
        placeholderText="edit-members-modal-placeholder"
      />
    </div>
  )
}

MembersSearch.propTypes = {
  getUsers: PropTypes.func.isRequired,
  groupName: PropTypes.string,
}

MembersSearch.defaultProps = {
  groupName: '',
}

export default MembersSearch
